export const UPDATE_FIRSTNAME = "UPDATE_FIRSTNAME";
export const UPDATE_LASTNAME = "UPDATE_LASTNAME";
export const UPDATE_EMAIL = "UPDATE_EMAIL";
export const UPDATE_ISMEMBER = "UPDATE_ISMEMBER";
export const UPDATE_BRANCH = "UPDATE_BRANCH";
export const UPDATE_PHONE = "UPDATE_PHONE";
export const UPDATE_MISC = "UPDATE_MISC";
export const ADD_ERRORFIELD = "ADD_ERRORFIELD";
export const REMOVE_ERRORFIELD = "REMOVE_ERRORFIELD";
export const SET_SUBMITTED = "SET_SUBMITTED"

const initialState = {
    "firstname": undefined,
    "lastname": undefined,
    "email": undefined,
    "ismember": 'No',
    "branch": undefined,
    validationErrors: []
};

export default function usrFields(state = initialState, action){
    switch(action.type){
        case UPDATE_FIRSTNAME:
            return{
                ...state,
                "firstname": action.value
            }
        case UPDATE_LASTNAME:
            return{
                ...state,
                "lastname": action.value
            }
        case UPDATE_EMAIL:
            return{
                ...state,
                "email": action.value
            }
        case UPDATE_ISMEMBER:
            return{
                ...state,
                "ismember": action.value
            }
        case UPDATE_BRANCH:
            return{
                ...state,
                "branch": action.value
            }
        case UPDATE_PHONE:
            return{
                ...state,
                "phone": action.value
            }
        case UPDATE_MISC:
            return{
                ...state,
                [action.title]: action.value
            }
        case SET_SUBMITTED:
            return{
                ...state,
                'submitted': true
            }
        case ADD_ERRORFIELD:
            return{
                ...state,
                'validationErrors': [...state.validationErrors, action.value]
            }
        case REMOVE_ERRORFIELD:
            return{
                ...state,
                'validationErrors': state.validationErrors.filter((x)=>x !== action.value)
            }
        default:
            return state
    }
}